module.exports = __webpack_public_path__ + "static/media/ic_upload.b84f9e84.svg";